export default __webpack_public_path__ + "static/char-s-45-zh-Hant-1b87851a1f25554fe8a0c52e8906a9a9.png";